// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"e7e9187d","472":"35892425","863":"9cbacc08"}[chunkId] + ".chunk.js";
};